import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      className="fixed top-0 left-0 w-full h-full bg-stone-50 flex flex-col items-center justify-center z-[100]"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <motion.div
        className="flex flex-col items-center"
        variants={itemVariants}
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.2 }}
      >
        <motion.img
          src="https://i.ibb.co/LXJTgwM9/Chat-GPT-Image-19-mai-2025-15-18-31.png"
          alt="CoJeCo Logo"
          className="h-32 w-32 rounded-full shadow-md bg-white p-1 mb-8"
          variants={itemVariants}
        />
        <motion.div
          className="mt-8 w-48 h-1 bg-stone-200 rounded-full overflow-hidden"
          variants={itemVariants}
        >
          <motion.div
            className="h-full bg-gradient-to-r from-primary to-secondary"
            initial={{ width: 0 }}
            animate={{ width: '100%' }}
            transition={{ duration: 3, ease: 'linear', repeat: Infinity }}
          ></motion.div>
        </motion.div>
        <motion.p className="mt-4 text-stone-600" variants={itemVariants}>
          {t('loading.message')}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};